export default "__VITE_ASSET__B$XGQfvO__"